<mat-dialog-content>
  <iframe *ngIf="!reportUser"
    src="https://docs.google.com/forms/d/e/1FAIpQLSeDgdM09ytGoSOoLumhAO4G-6oFnUNvIEjCffLbSH7MwAPM0A/viewform?embedded=true"
    width="640" height="576" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
  <iframe *ngIf="reportUser" scrolling="no"
    src="https://docs.google.com/forms/d/e/1FAIpQLSde1O3kBajLXDaiboI-dUJqYyWUF7GwOf4xnBDJgjQsPGlEWQ/viewform?embedded=true"
    width="640" height="1291" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
</mat-dialog-content>
